module.exports = __webpack_public_path__ + "img/client-logo.e4c89803.png";